export const ERROR_GROUPS = {
    SEGMENT_LAYOUT: "segment_layout"
};
